import React from "react";

import Price from "@components/Product/ProductTile/components/price/price.container";

type ProductBundlePriceComponentProps = {
    showStrippedPrice: boolean;
    salesPrice: number;
    strikethroughPrice?: number;
    className?: string;
};

const ProductBundlePriceComponent = ({
    showStrippedPrice,
    salesPrice,
    strikethroughPrice,
    className,
}: ProductBundlePriceComponentProps) => (
    <Price
        className={className}
        showStrippedPrice={showStrippedPrice}
        showConvertedPriceAsMainPrice={false}
        strikethroughPrice={strikethroughPrice}
        salesPrice={salesPrice}
    />
);

export { ProductBundlePriceComponent };
